// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".area-letter{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#8a8a8a}.area-letter .info-text{margin-left:10px}.list-channels .flex{border-bottom:1px solid rgba(0,0,0,.12)}.list-channels .flex:last-child{border-bottom:none}.v-expansion-panel.card-checked-panel:before{-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;
